import React, { forwardRef } from "react";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
export const ComboboxInput = forwardRef((props, ref) => {
    const styles = useMultiStyleConfig("Combobox");
    return (React.createElement(chakra.input, { ref: ref, "data-1p-ignore": true, __css: styles["input"], type: "text", ...props }));
});
